// No Zod here: the web app imports this at startup.

/** Page routes that may be reported with speed measurements; anything else is refused. */
export const VITALS_ROUTES = [
  '/collection', '/add', '/add/copy', '/copies/$id/edit', '/releases/$id/edit', '/import', '/settings', '/settings/appearance',
  '/settings/about', '/settings/about/licenses', '/settings/admin', '/settings/admin/users', '/settings/admin/status',
  '/settings/admin/defaults', '/settings/admin/appearance', '/settings/admin/activity', 'other',
] as const;
